import { forwardRef } from 'react';

import type { BoxProps } from '../../Box/Box';
import { Box } from '../../Box/Box';

export interface Props extends Omit<BoxProps, 'cssClass'> {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
  reserveScrollbarSpace?: boolean;
}

export const Body = forwardRef<unknown, Props>(({ children, style, reserveScrollbarSpace, ...boxProps }, ref) => (
  <Box
    ref={ref}
    style={{
      ...(reserveScrollbarSpace && {
        scrollbarGutter: 'stable',
        overflowY: 'auto',
      }),
      ...style,
    }}
    {...boxProps}
  >
    {children}
  </Box>
));
